const BASE = process.env.NODE_ENV === "production"
  ? "https://rizzglam.co.in/api"
  : "http://localhost:5000/api";

const getToken = () => localStorage.getItem("rizzglam_token");

const headers = (auth = false) => ({
  "Content-Type": "application/json",
  ...(auth && getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
});

// ── Auth ──────────────────────────────────
export const apiRegister = (data) =>
  fetch(`${BASE}/auth/register`, { method: "POST", headers: headers(), body: JSON.stringify(data) }).then(r => r.json());

export const apiLogin = (data) =>
  fetch(`${BASE}/auth/login`, { method: "POST", headers: headers(), body: JSON.stringify(data) }).then(r => r.json());

export const apiGetProfile = () =>
  fetch(`${BASE}/auth/profile`, { headers: headers(true) }).then(r => r.json());

export const apiUpdateProfile = (data) =>
  fetch(`${BASE}/auth/profile`, { method: "PUT", headers: headers(true), body: JSON.stringify(data) }).then(r => r.json());

// ── Upload ───────────────────────────────
export const apiUploadImage = (file) => {
  const form = new FormData();
  form.append("image", file);
  return fetch(`${BASE}/upload`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken()}` },
    body: form,
  }).then(r => r.json());
};

// ── Products ──────────────────────────────
export const apiGetProducts = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return fetch(`${BASE}/products${q ? "?" + q : ""}`).then(r => r.json());
};

export const apiGetProduct = (id) =>
  fetch(`${BASE}/products/${id}`).then(r => r.json());

export const apiAddProduct = (data) =>
  fetch(`${BASE}/products`, { method: "POST", headers: headers(true), body: JSON.stringify(data) }).then(r => r.json());

export const apiUpdateProduct = (id, data) =>
  fetch(`${BASE}/products/${id}`, { method: "PUT", headers: headers(true), body: JSON.stringify(data) }).then(r => r.json());

export const apiDeleteProduct = (id) =>
  fetch(`${BASE}/products/${id}`, { method: "DELETE", headers: headers(true) }).then(r => r.json());

// ── Reviews ───────────────────────────────
export const apiGetReviews = (productId) =>
  fetch(`${BASE}/reviews/${productId}`).then(r => r.json());

export const apiAddReview = (data) =>
  fetch(`${BASE}/reviews`, { method: "POST", headers: headers(true), body: JSON.stringify(data) }).then(r => r.json());

export const apiDeleteReview = (id) =>
  fetch(`${BASE}/reviews/${id}`, { method: "DELETE", headers: headers(true) }).then(r => r.json());

// ── Orders ───────────────────────────────
export const apiGetOrders = () =>
  fetch(`${BASE}/orders`, { headers: headers(true) }).then(r => r.json());

export const apiPlaceOrder = (data) =>
  fetch(`${BASE}/orders`, { method: "POST", headers: headers(true), body: JSON.stringify(data) }).then(r => r.json());

// Guest order (no auth needed)
export const apiPlaceOrderGuest = (data) =>
  fetch(`${BASE}/orders`, { method: "POST", headers: headers(), body: JSON.stringify(data) }).then(r => r.json());

export const apiUpdateOrderStatus = (id, status) =>
  fetch(`${BASE}/orders/${id}/status`, { method: "PATCH", headers: headers(true), body: JSON.stringify({ status }) }).then(r => r.json());

export const apiApproveRejectPayment = (id, payment_status, admin_note) =>
  fetch(`${BASE}/orders/${id}/payment`, { method: "PATCH", headers: headers(true), body: JSON.stringify({ payment_status, admin_note }) }).then(r => r.json());

export const apiGetOrderStatus = (id) =>
  fetch(`${BASE}/orders/${id}/status`).then(r => r.json());

export const apiGetMyOrders = () =>
  fetch(`${BASE}/orders/my`, { headers: headers(true) }).then(r => r.json());

export const apiTrackOrders = (phone) =>
  fetch(`${BASE}/orders/track/${phone}`).then(r => r.json());

export const apiCancelOrder = (id, customer_phone) =>
  fetch(`${BASE}/orders/${id}/cancel`, { method: "PATCH", headers: headers(), body: JSON.stringify({ customer_phone }) }).then(r => r.json());

// ── Categories ────────────────────────────
export const apiGetCategories = () =>
  fetch(`${BASE}/categories`).then(r => r.json());

// ── Users (admin) ─────────────────────────
export const apiGetUsers = () =>
  fetch(`${BASE}/auth/users`, { headers: headers(true) }).then(r => r.json());
